import { MAP_DEFAULTS } from '@app/consts';
import { LocationType, LocationTypeEnum } from '@app/enums';
import { environment } from '@app/environments/environment';
import { GeoTileModel } from '@app/models/geo.tiles.model';
import { EsServiceBase } from '@app/services/abstracts/es-service.base';

const GEO_TILES_INDEX_MAP = {
    [LocationTypeEnum.City]: 'noc-geo-tiles-cities',
    [LocationTypeEnum.Country]: 'noc-geo-tiles-countries',
    [LocationTypeEnum.Region]: 'noc-geo-tiles-regions',
    [LocationTypeEnum.Voivodeship]: 'noc-geo-tiles-voivodeships',
};

export class EsGeoTilesService extends EsServiceBase {
    private static _instance: EsGeoTilesService;
    private readonly _defaultVersion = environment.GEO_TILES_ES_VERSION;

    public static get instance(): EsGeoTilesService {
        if (!this._instance) {
            this._instance = new EsGeoTilesService();
        }
        return this._instance;
    }

    protected indexName(locationType: LocationType, version?: number): string {
        const baseName =
            GEO_TILES_INDEX_MAP[locationType as keyof typeof GEO_TILES_INDEX_MAP] ??
            GEO_TILES_INDEX_MAP[LocationTypeEnum.Country];

        return `${baseName}-${version ?? this._defaultVersion}`;
    }

    public async getTilesForGeo(
        geoId: string,
        locationType: LocationType,
        indexVersion?: number,
    ): Promise<GeoTileModel[]> {
        const finalGeoId = locationType in GEO_TILES_INDEX_MAP ? geoId : MAP_DEFAULTS.GEO_ID;
        const finalIndexName = this.indexName(locationType, indexVersion);

        try {
            const response = await this.get<{ tiles: GeoTileModel[] }>(
                finalIndexName,
                finalGeoId,
                '_doc',
                { _source: 'tiles.bbox' },
            );

            return response._source?.tiles ?? [];
        } catch (err) {
            console.warn(
                `GeoTiles index not found for ${locationType} (index: ${finalIndexName}):`,
                err,
            );
            return [];
        }
    }
}
